import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { ListItemResponse } from '../../Models/Models';
import { SiteContext } from '../../Contexts';
import { ListItemService } from '../../Services/ListItemService';
import { EntityColors } from '../../Themes/EntityColors';
import DeleteButton from '../Buttons/DeleteButton';
import SaveButton from '../Buttons/SaveButton';
import DiscardButton from '../Buttons/DiscardButton';
import { Utils } from '../../Services/Utils';
import ReusableModal from '../Modals/ReusableModal';
import FormShell from '../Form/FormShell';
import RequiredLabel from "../Form/RequiredLabel";
import CharCount from '../Form/CharCount';
import { FieldLengths } from '../../Models/FieldLengths';
import { useIsDirty } from '../../Hooks/useIsDirty';

const ListItemEditComponent = () => {
    useEffect(() => {
        Utils.setDocumentTitle('Úprava položky zoznamu');
    }, []);

    const { action, icon } = EntityColors.list;
    const { getListItem, updateListItem, deleteListItem } = ListItemService();
    const { currentSite }: any = useContext(SiteContext);
    const { listItemId } = useParams();

    const [listItem, setListItem] = useState<ListItemResponse>({ id: -1, listId: -1, text: '' });
    const [deleteModal, setDeleteModal] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const isDirty = useIsDirty(listItem, loaded);

    useEffect(() => {
        const load = async () => {
            try {
                const response = await getListItem(Number(listItemId));
                if (!response || typeof response !== 'object') throw new Error('Neplatná odpoveď zo servera.');
                setListItem(response as ListItemResponse);
                setLoaded(true);
            } catch (err: any) {}
        };
        void load();
    }, [listItemId]);

    const handleDelete = async (e: React.FormEvent) => {
        e.preventDefault();
        await deleteListItem(listItem.id);
    };

    const doSave = async () => {
        await updateListItem(listItem);
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        void doSave();
    };

    return (
        <>
            <FormShell title="Editovať položku zoznamu" icon={icon} accentColor={action} backHref="/list/table" isDirty={isDirty}>
                {!loaded ? (
                    <p className="text-center py-4 text-secondary">Načítavam...</p>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <div className="st-field-head">
                                <RequiredLabel>Text</RequiredLabel>
                                <CharCount value={listItem.text} max={FieldLengths.listItemText} />
                            </div>
                            <Form.Control
                                required
                                maxLength={FieldLengths.listItemText}
                                value={listItem.text}
                                onChange={e => setListItem({ ...listItem, text: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <div className="st-field-head">
                                <Form.Label>Odkaz</Form.Label>
                                <CharCount value={listItem.link} max={FieldLengths.listItemLink} />
                            </div>
                            <Form.Control
                                type="url"
                                placeholder="(nepovinné) napr. https://example.sk"
                                maxLength={FieldLengths.listItemLink}
                                value={listItem.link}
                                onChange={e => setListItem({ ...listItem, link: e.target.value })}
                            />
                        </Form.Group>

                        <div className="d-flex justify-content-center mt-4 gap-3">
                            <DeleteButton onClick={() => setDeleteModal(true)} />
                            <DiscardButton to="/list/table" isDirty={isDirty} />
                            <SaveButton type="submit" onSave={doSave} websiteId={currentSite.id} />
                        </div>
                    </form>
                )}
            </FormShell>

            <ReusableModal
                show={deleteModal}
                title="Naozaj chcete zmazať túto položku?"
                description="Položka bude nenávratne odstránená zo zoznamu."
                onHide={() => setDeleteModal(false)}
                onSubmit={handleDelete}
            />
        </>
    );
};

export default ListItemEditComponent;
